import {
  FETCH_PROFILE_REQUEST, FETCH_PROFILE_SUCCESS, UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS, UPDATE_PROFILE_FAILURE,
} from './shared';


export const TOGGLE_TESTIMONIALS = 'crowdspring/profile/TOGGLE_TESTIMONIALS';
export const TOGGLE_BACKGROUND_SELECTOR = 'crowdspring/profile/TOGGLE_BACKGROUND_SELECTOR';
export const TOGGLE_AVATAR_SELECTOR = 'crowdspring/profile/TOGGLE_AVATAR_SELECTOR';
export const SELECT_AVATAR = 'crowdspring/profile/SELECT_AVATAR';

export const INITIAL_STATE = {
  data: null,
  isLoading: false,
  isSaving: false,
  showAllTestimonials: false,
  showAllMetaOnMobile: false,
  showBackgroundSelector: false,
  showAvatarSelector: false,
  selectedAvatar: null,
};

export function toggleTestimonials() {
  return {
    type: TOGGLE_TESTIMONIALS,
  };
}

export function toggleBackgroundSelector() {
  return {
    type: TOGGLE_BACKGROUND_SELECTOR,
  };
}

export function toggleAvatarSelector() {
  return {
    type: TOGGLE_AVATAR_SELECTOR,
  };
}

export function selectAvatar(image) {
  return {
    type: SELECT_AVATAR,
    payload: image,
  };
}

export default function reducer(state = INITIAL_STATE, action) {
  if (!action) {
    return INITIAL_STATE;
  }

  switch (action.type) {
    case FETCH_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload
      };
    case UPDATE_PROFILE:
      return {
        ...state,
        isSaving: true,
      };
    case UPDATE_PROFILE_SUCCESS:
      const data = {
        ...state.data,
        ...action.payload
      };

      return {
        ...state,
        isSaving: false,
        data
      };
    case UPDATE_PROFILE_FAILURE:
      return {
        ...state,
        isSaving: false,
      };
    case TOGGLE_TESTIMONIALS:
      return {
        ...state,
        showAllTestimonials: !state.showAllTestimonials,
      };
    case TOGGLE_BACKGROUND_SELECTOR:
      return {
        ...state,
        showBackgroundSelector: !state.showBackgroundSelector,
      };
    case TOGGLE_AVATAR_SELECTOR:
      return {
        ...state,
        showAvatarSelector: !state.showAvatarSelector,
        selectedAvatar: null,
      };
    case SELECT_AVATAR:
      return {
        ...state,
        selectedAvatar: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./profile/ducks/view.js